import {
    JsonTimesheetEntryModel,
    TimesheetEntryModel,
    TimesheetEntryModelFromJson,
} from '../complex/timesheet-entry.model';
import { JsonTextModel, TextModel, TextModelFromJson } from '../primitive/text.model';
import { ExpenseModel, ExpenseModelFromJson, JsonExpenseModel } from './expense.model';
import {
    JsonNotificationIdentifierModel,
    NotificationIdentifierModel,
    NotificationIdentifierModelFromJson,
} from './notification-identifier.model';

export class TimesheetNotificationModel {
    public constructor(
        public notificationId: NotificationIdentifierModel,
        public timesheetEntries: TimesheetEntryModel[],
        public expenses: ExpenseModel[],
        public distance: TextModel,
        public customerName: string,
        public isConfirmationSubmitted = true,
    ) {}
}

export class TimesheetNotificationModelFromJson extends TimesheetNotificationModel {
    public constructor(data: JsonTimesheetNotificationModel) {
        super(
            new NotificationIdentifierModelFromJson(data.notificationId),
            data.timesheetEntries
                ? data.timesheetEntries.map((entry) => {
                      return new TimesheetEntryModelFromJson(entry);
                  })
                : [],
            data.expenses ? data.expenses.map((expense) => new ExpenseModelFromJson(expense)) : [],
            new TextModelFromJson(data.distance),
            data.customerName,
            data.isConfirmationSubmitted,
        );
    }
}

export interface JsonTimesheetNotificationModel {
    notificationId: JsonNotificationIdentifierModel;
    timesheetEntries: JsonTimesheetEntryModel[];
    expenses: JsonExpenseModel[];
    distance: JsonTextModel;
    customerName: string;
    isConfirmationSubmitted: boolean;
}
